<script setup>
import {ref, onMounted} from "vue";
import YTTransfer from "@/components/YTTransfer/index.vue"
import {
  detailTagGroupTagPool,
  detailUsageScenarioTagPool,
  editTagGroupTagPool,
  editTagScenarioTagPool
} from "@/api/tag/tag.js";

onMounted(async () => {
  await getDetail('init')
})

// 加载状态
const loading = ref(false)
// 获取分组信息
const getDetail = async (type = 'init') => {
  try {
    loading.value = true
    const res = await detailUsageScenarioTagPool(currentScenario.value)
    console.log("res", res)
    groupsInfo.value = res.tagGroup
    selected.value = res.selectedPool
    unselected.value = res.unselectedPool
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 标签分组信息
const groupsInfo = ref()

/*穿梭框相关功能*/
// 已选标签
const selected = ref([])
// 未选标签
const unselected = ref([])
// 处理添加标签
const handleAddTag = async (info, infoGroup) => {
  try {
    loading.value = true
    let param = {
      usageScenario: currentScenario.value,
      tagIdList: info,
      tagGroupIdList: infoGroup
    }
    await editTagScenarioTagPool(param)
    ElMessage.success("添加成功")
    await getDetail()
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 处理移除标签
const handleRemoveTag = async (info, infoGroup) => {
  try {
    loading.value = true
    let param = {
      usageScenario: currentScenario.value,
      tagIdList: info,
      tagGroupIdList: infoGroup
    }
    await editTagScenarioTagPool(param)
    ElMessage.success("移除成功")
    await getDetail()
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 当前应用场景组
const currentScenario = ref("ACTIVITY")
// 处理获取相应场景的标签
const handleGetScenarioTags = (scenario) => {
  currentScenario.value = scenario
  getDetail()
}
</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px">
    <div class="flex_center flex_left mg_l_2" v-loading="loading">
      <YTTransfer ref="YTTransferRef" :isSecond="true" :selected="selected" :unselected="unselected" @to-left="handleRemoveTag" @to-right="handleAddTag" @change-scenario="handleGetScenarioTags"></YTTransfer>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ytCard_box {
  width: 100%;
  text-align: left;
  margin-bottom: 24px;
  padding: 20px 0 0 20px;
  .ytCard_title_box {
    margin-bottom: 20px;
    box-sizing: border-box;
    .ytCard_title_line {
      width: 4px;
      height: 32px;
      background: #796CB4;
      border-radius: 2px;
      margin-right: 15px;
    }
    .ytCard_title {
      margin-right: 20px;
      font-weight: bold;
      font-size: 18px;
      color: #000000;
    }
  }
}
</style>
